import { ICON_COLOR } from '@zep-us/zus';
import { logger } from '@zep/core-logger';
import { useOpenWindow } from '@/hooks/useLocale';
import { ChevronRightIcon } from '@/icons';
import { cn } from '@/utils/tailwind.util';
interface SubHeaderProps {
  thumbnailUrl: string;
  title: string;
  authorName: string;
  authorId: string;
  isVisible: boolean;
}
export const SubHeader = ({
  thumbnailUrl,
  title,
  authorName,
  authorId,
  isVisible
}: SubHeaderProps) => {
  const openWindow = useOpenWindow();
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    logger.track('click_user_profile');
    openWindow(`/profile/${authorId}`);
  };
  return <div className="sticky left-0 right-0 top-[58px] z-30 h-0" data-sentry-component="SubHeader" data-sentry-source-file="SubHeader.tsx">
      <div className={cn('h-[56px] border-b border-gray-200 bg-white px-md shadow-md tablet-sm:h-[66px]', isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0 pointer-events-none')}>
        <div className="mx-auto flex h-full max-w-[1024px] items-center gap-lg">
          {/* Left: Icon + Title */}
          <div className="flex min-w-0 flex-1 items-center gap-xs tablet-sm:gap-lg">
            {/* Icon Container */}
            <div className="relative h-xl w-[52px] shrink-0 overflow-hidden rounded-sm tablet-sm:h-[42px] tablet-sm:w-3xl">
              <img src={thumbnailUrl} alt={title} className="h-full w-full object-cover" />
            </div>

            {/* Title */}
            <h2 className="min-w-0 flex-1 truncate text-body-lg-bold text-default tablet-sm:text-heading-sm-bold">
              {title}
            </h2>
          </div>

          {/* Right: Author */}
          <div className="flex shrink-0 items-center gap-xs">
            <div className="flex items-center gap-4xs">
              <span className="cursor-pointer text-body-md-semibold text-neutral hover:text-assistive" onClick={handleClick}>
                {authorName}
              </span>
              <div className="flex h-4 w-4 items-center justify-center">
                <ChevronRightIcon size="2xs" fill={ICON_COLOR.neutral} data-sentry-element="ChevronRightIcon" data-sentry-source-file="SubHeader.tsx" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};